import { Accordion } from 'flowbite-react';
const SupplyChainManagementFAQ: React.FC = () => {
    return (
        <>
            <Accordion>
                <Accordion.Panel>
                    <Accordion.Title as="h3" className="accordion-title">
                        How can IT services enhance supply chain visibility and transparency?
                    </Accordion.Title>
                    <Accordion.Content className="accordion-border">
                        <div className="fs-md mb-0 text-secondary">
                            By integrating data across systems and automating reporting, IT services provide a real-time view of
                            your entire supply chain. Dashboards, alerts, and live updates help teams identify issues faster,
                            reduce blind spots, and make informed decisions at every stage.
                        </div>
                    </Accordion.Content>
                </Accordion.Panel>
                <Accordion.Panel>
                    <Accordion.Title as="h3" className="accordion-title">
                        What is AI in supply chain management?
                    </Accordion.Title>
                    <Accordion.Content className="accordion-border">
                        <div className="fs-md mb-0 text-secondary">
                            AI in SCM refers to the use of machine learning and intelligent algorithms to predict demand, optimize
                            routes, and automate workflows. It brings real-time adaptability, reduces manual intervention, and
                            ensures faster, more precise operations.
                        </div>
                    </Accordion.Content>
                </Accordion.Panel>
                <Accordion.Panel>
                    <Accordion.Title as="h3" className="accordion-title">
                        How do we optimize the cost of supply chain software implementation?
                    </Accordion.Title>
                    <Accordion.Content className="accordion-border">
                        <div className="fs-md mb-0 text-secondary">
                            We focus on building only what your business needs—nothing more, nothing less. By reusing tested
                            components, streamlining integrations, and avoiding feature bloat, we keep costs efficient without
                            compromising on performance.
                        </div>
                    </Accordion.Content>
                </Accordion.Panel>
                <Accordion.Panel>
                    <Accordion.Title as="h3" className="accordion-title">
                        What are the benefits of AI in supply chain management?
                    </Accordion.Title>
                    <Accordion.Content className="accordion-border">
                        <div className="fs-md mb-0 text-secondary">
                            AI unlocks faster decision-making, improves forecasting accuracy, and minimizes supply chain
                            disruptions. It also reduces operational costs and helps you deliver better customer experiences with
                            fewer errors and delays.
                        </div>
                    </Accordion.Content>
                </Accordion.Panel>
            </Accordion>
        </>
    );
};

export default SupplyChainManagementFAQ;
